import { render } from "./InitialView.vue?vue&type=template&id=1ae27d99&lang=pug"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__